import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/aulas/aula';
import RecuperacionesAdmin from './Recuperaciones';


const ms2p = (state) => {
    return {
        me: state.login.me,
        ...state.aula,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(RecuperacionesAdmin);
